import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";
import { StrategyDspFunnel } from "@front/m19-api-client";

@Component({
  selector: "app-dsp-funnel-icon",
  template: `<svg
    width="4rem"
    height="4rem"
    class="fill-main-500 text-gray-300"
    viewBox="0 0 411 336"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      [attr.fill]="funnel() === StrategyDspFunnel.AWARENESS ? '' : 'currentColor'"
      d="M1.4135 14.5419C-1.97837 7.88859 2.85457 0 10.3226 0H400.677C408.145 0 412.978 7.88859 409.586 14.5419L367.783 96.5419C366.075 99.8913 362.633 102 358.874 102H52.1265C48.3669 102 44.925 99.8913 43.2174 96.5419L1.4135 14.5419Z"
    ></path>
    <path
      [attr.fill]="funnel() === StrategyDspFunnel.CONSIDERATION ? '' : 'currentColor'"
      d="M61.7296 131.663C58.2192 125.004 63.0478 117 70.5758 117H341.424C348.952 117 353.781 125.004 350.27 131.663L307.045 213.663C305.314 216.946 301.909 219 298.198 219H113.802C110.091 219 106.686 216.946 104.955 213.663L61.7296 131.663Z"
    ></path>
    <path
      [attr.fill]="funnel() === StrategyDspFunnel.CONVERSION ? '' : 'currentColor'"
      d="M122.786 248.684C119.254 242.024 124.082 234 131.621 234H280.379C287.918 234 292.746 242.024 289.214 248.684L245.738 330.684C244.004 333.955 240.605 336 236.903 336H175.097C171.395 336 167.996 333.955 166.262 330.684L122.786 248.684Z"
    ></path>
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspFunnelIconComponent {
  readonly selectedFunnel = model<StrategyDspFunnel | undefined>(undefined);

  readonly StrategyDspFunnel = StrategyDspFunnel;
  readonly funnel = input.required<StrategyDspFunnel>();
}
